















































































































import { Component, Prop, Vue } from "vue-property-decorator";
import User from "@/apiClient/User";
import { mapGetters } from "vuex";
import _ from "lodash";
import { TranslateResult } from 'vue-i18n';

declare var mApp: any;

@Component({
  name: "MailEdit",
  components: {},
  computed: {
    ...mapGetters(["getUser"]),
    userEmail() {
      return this.getUser.mail ? this.getUser.mail : "";
    },
  },
})
export default class MailEdit extends Vue {
  @Prop({ required: true }) email: string;
  getUser!: any[];
  user: User;
  form: {
    password: null;
    email: null;
    error: null;
  };
  loading: boolean;
  messageSuccess: TranslateResult;
  isSuccessMessage: boolean;

  created() {
    this.user = new User();
  }
  updated() {
    if (typeof mApp !== "undefined") mApp.init({});
  }
  data() {
    return {
      user: User,
      form: {
        password: "",
        email: "",
        error: null,
      },
      loading: false,
      messageSuccess: "",
      isSuccessMessage: false,
    };
  }
  clear() {
    this.form = _.mapValues(this.form, _.constant(null));
    this.$validator.reset();
  }
  submit() {
    this.loading = true;
    this.$validator.validate().then((result) => {
      if (result) {
        this.user
          .changeEmail(this.form.password, this.form.email)
          .then((response) => {
            if (response.data.results.data[0]) {
              this.isSuccessMessage = true;
              this.messageSuccess = this.$t(
                "message.header_top_bar_mail_changed_message"
              );
              this.$store.dispatch("setUser", {
                user: Object.assign({}, this.getUser, {
                  mail: this.form.email,
                }),
              });

              localStorage.setItem(
                "user",
                JSON.stringify(
                  Object.assign({}, JSON.parse(localStorage.getItem("user")), {
                    mail: this.form.email,
                  })
                )
              );
              this.clear();
            }
            this.loading = false;
          })
          .catch((error) => {
            this.loading = false;
            let response = error.response.data;
            this.form.error = response.results.data[0];
          });
      }
    });
  }
}
